// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"ShareLinks_MainContainer__2Wi7l"};